<style>
.modal-popup {
  position: absolute;
  right: calc(10% - (100vw - 100%));
  top: 85%;
  left: -650%;
  z-index: 9999;
  background: rgb(255, 255, 255);
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  overflow-y: scroll;
  max-height: 500px !important;
  width: 260px;
  animation: aparecer 1s;
}
@media (max-width: 720px) {
  .modal-popup {
    left: -1130%;
  }
}
@keyframes aparecer {
  from {
    opacity: 0;
    transform: translate(10%, -10%);
  }
  to {
    opacity: 1;
    transform: translate(0);
  }
}
</style>
<template>
  <div class="form-group">
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.producto,
      }"
      >{{ titulo }}</label
    >
    <div class="row">
      <div class="col-11">
        <v-select
          label="sku"
          v-model="current.producto"
          :filterable="false"
          @input="onChangeProducto($event)"
          @click="onChangeProducto"
          :options="productos"
          :disabled="disabled"
          @search="onSearch"
          placeholder="Producto..."
        >
          <template slot="no-options">Producto...</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <img :src="option.image" />
              {{ option.sku }} - {{ option.nombre }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              <img :src="option.image" />
              {{ option.sku }} - {{ option.nombre }}
            </div>
          </template>
        </v-select>
      </div>
      <div class="col-1" style="padding: 0px">
        <a
          v-if="current.producto && current.producto.sku"
          @click="mostrarDetalle()"
          class="btn btn-info btn-sm"
        >
          <i class="fas fa-eye"></i
        ></a>
        <div v-if="showModal" class="modal-popup">
          <div>
            <!-------------------- Tabla de REsultados -------------------->
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="text-center">Tienda</th>
                  <th class="text-center">Sol. auto</th>
                  <th class="text-center">Compra Local</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="det in producto_tienda.results" v-bind:key="det.id">
                  <td class="text-center">{{ det.tienda }}</td>
                  <td class="text-center">
                    <div
                      v-bind:class="{
                        green: det.sol_auto == true,
                        red: det.sol_auto == false,
                      }"
                      class="status-pill"
                    ></div>
                  </td>
                  <td class="text-center">
                    <div
                      v-bind:class="{
                        green: det.compra_local == true,
                        red: det.compra_local == false,
                      }"
                      class="status-pill"
                    ></div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-------------------- END - Basic Table -------------------->
          </div>
          <button @click="showModal = false" class="btn btn-dark btn-sm">Cerrar</button>
        </div>
        <button
          v-if="!current.producto"
          :disabled="true"
          @click="mostrarDetalle()"
          class="btn btn-info btn-sm"
        >
          <i class="fas fa-eye"></i>
        </button>
      </div>
    </div>
    <small
      v-if="current.errors && current.errors.producto"
      class="form-text text-danger"
      >{{ current.errors.producto }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import BuzonSugerenciasFormComponent from "../rrhh/buzon_sugerencias/BuzonSugerenciasFormComponent.vue";

export default {
  components: { BuzonSugerenciasFormComponent },
  computed: {
    ...mapGetters({
      productos: "catalogos/productos",
    }),
  },
  data() {
    return {
      showModal: false,
      params: {},
      producto_tienda: {
        errors: {},
      },
    };
  },

  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: "Producto",
    },
    tienda: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.$store.dispatch("catalogos/productos", {
      activo: true,
      quitar_paginacion: true,
    });
  },
  methods: {
    mostrarDetalle() {
      let self = this;
      let params = {};
      if (this.showModal == true) {
        this.showModal = false;
        return;
      }
      if (self.producto && self.params.producto == self.current.producto.sku) {
        self.showModal = true;
        return;
      }
      self.params.producto = self.current.producto.sku;
      if (self.current.tienda) {
        self.params.tienda = self.current.tienda;
      }
      DynamicService.fetch("cat", "producto-tienda", self.params).then((response) => {
        self.producto_tienda = response.data;
        console.log(self.producto_tienda.results);
        self.showModal = true;
      });
    },
    onChangeProducto(event) {
      let self = this;
      self.showModal = false;
      self.producto_tienda = "";
      this.$emit("onChangeProducto", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/productos", {
        page: 1,
        activo: true,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>
